import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_STAFF_ACCOUNTS_DETAIL_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_STAFF_ACCOUNTS_DETAIL_API';

const apiCall = createApiCall(
  FETCH_INVESTCORE_STAFF_ACCOUNTS_DETAIL_API_ID,
  ({ id }: { id: string }) => ({
    endpoint: `/api/admin/staff-accounts/${id}`,
    method: 'GET',
  })
);

export default apiCall;
